import { Body, Image, Spacer } from '@spritz-finance/ui'
import { GlassCard } from '../../../../components/Layout/GlassCard'
import { Row } from '../../../../components/Layout/Row'
import { ThemedHeroImage } from '../../../../components/ThemedHeroImage'
import { AddAccount } from './AddAccount'

export const AddFirstAccountCard = () => {
    return (
        <GlassCard>
            <Row align="center">
                <ThemedHeroImage>
                    <Image.BankTransfer height={74} />
                </ThemedHeroImage>
            </Row>
            <Spacer height={16} />
            <Row align="center">
                <Body.Bold size={22}>You haven't added any bank accounts</Body.Bold>
            </Row>
            <Spacer height={16} />
            <Row align="center">
                <Body.Reg size={16} align="center">
                    Off-ramp crypto to any bank in a single transaction.
                </Body.Reg>
            </Row>

            <Spacer height={40} />
            <Row align="center">
                <AddAccount />
            </Row>
            <Spacer height={24} />
        </GlassCard>
    )
}
